const pad2 = value => String(value).padStart(2, '0');

const durationCell = value => {
  const total = Math.round(Number(value));
  if (!Number.isFinite(total) || total <= 0) return '';

  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  if (days > 0) return `${days}d ${pad2(hours)}h ${pad2(minutes)}min`;
  if (hours > 0) return `${hours}h ${pad2(minutes)}min ${pad2(seconds)}s`;
  if (minutes > 0) return `${minutes}min ${pad2(seconds)}s`;
  return `${seconds}s`;
};

const textCell = value => (value == null ? '' : String(value));

const phoneCell = value => textCell(value).trim();

const countCell = value => {
  if (value == null || value === '') return '';
  const number = Number(value);
  return Number.isFinite(number) ? number : '';
};

const countOrZero = value => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const blanks = length => Array.from({ length }, () => '');

const effortCells = (source, { zero }) => {
  const count = zero ? countOrZero : countCell;
  return [
    count(source.conversationsCount),
    count(source.messagesCount),
    count(source.resolvedConversationsCount),
    durationCell(source.totalResolutionTime),
    durationCell(source.avgResolutionTime),
    durationCell(source.avgFirstResponseTime),
    durationCell(source.avgReplyTime),
  ];
};

const periodRow = (periodLabel, width) => {
  if (!periodLabel) return null;
  return ['', periodLabel, ...blanks(width - 2)];
};

const companySheet = (rows, operation, labels, periodLabel) => {
  const headers = [
    labels.rank,
    labels.company,
    labels.domain,
    labels.companies,
    labels.contacts,
    labels.engagements,
    labels.messages,
    labels.resolved,
    labels.totalHandling,
    labels.avgHandling,
    labels.firstResponse,
    labels.replyTime,
  ];
  const total = [
    '',
    labels.operationTitle,
    '',
    countOrZero(operation.companiesCount),
    countOrZero(operation.contactsCount),
    ...effortCells(operation, { zero: true }),
  ];
  const data = rows.map((row, index) => [
    index + 1,
    textCell(row.name),
    textCell(row.domain),
    '',
    countOrZero(row.contactsCount),
    ...effortCells(row, { zero: true }),
  ]);

  return [headers, periodRow(periodLabel, headers.length), total, ...data].filter(
    Boolean
  );
};

const contactSheet = (rows, operation, labels, periodLabel) => {
  const headers = [
    labels.rank,
    labels.contact,
    labels.email,
    labels.phone,
    labels.companies,
    labels.contacts,
    labels.engagements,
    labels.messages,
    labels.resolved,
    labels.totalHandling,
    labels.avgHandling,
    labels.firstResponse,
    labels.replyTime,
  ];
  const total = [
    '',
    labels.operationTitle,
    '',
    '',
    countOrZero(operation.companiesCount),
    countOrZero(operation.contactsCount),
    ...effortCells(operation, { zero: true }),
  ];
  const data = rows.map((row, index) => [
    index + 1,
    textCell(row.name),
    textCell(row.email),
    phoneCell(row.phoneNumber),
    '',
    '',
    ...effortCells(row, { zero: true }),
  ]);

  return [headers, periodRow(periodLabel, headers.length), total, ...data].filter(
    Boolean
  );
};

export const buildContactRankingRows = ({
  ranking,
  rows,
  operation,
  periodLabel,
  labels,
}) =>
  ranking === 'contacts'
    ? contactSheet(rows, operation || {}, labels, periodLabel)
    : companySheet(rows, operation || {}, labels, periodLabel);
